import { useContext } from 'react';
import { useSelector } from 'react-redux';

import { AuthContext } from '../../context/AuthContext';
import { ManagerPermission } from '../../permission-profiles/permission';
import State from '../../app/store/state';
import { PendingActionsState } from '../../utils/pedingActionsReducer';

/**
 * Custom hook for authentication and permission checking
 */
export const useAuth = () => {
    const auth = useContext(AuthContext);
    const pendingActions: PendingActionsState = useSelector((state: State) => state.pendingActions);

    /**
     * Check if the current user has access to a specific feature
     */
    const hasFeatureAccess = (permission: ManagerPermission): boolean => {
        if (!auth?.manager?.profile?.permissions) {
            return false;
        }

        return auth.manager.profile.permissions.includes(permission);
    };

    /**
     * Get the current manager's ID
     */
    const getManagerId = (): string | null => {
        return auth?.manager?.id || null;
    };

    return {
        auth,
        pendingActions,
        hasFeatureAccess,
        getManagerId,
    };
};
